import React from 'react';
import EndoresementContent from '../function-components/EndoresementContent';

function Endorsements() {
    return (
        <>
            <EndoresementContent />
        </>
    )
}

export default Endorsements